<template>
  <div>
    <el-dialog
      title="分配服务人员"
      :visible.sync="dialogVisible"
      :modal="false"
      width="40%"
      top="30vh"
      @close="close"
      v-loading="loading">
      <div>
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)">
          {{tag}}
        </el-tag>
        <el-select
          ref="saveTagInput"
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          size="small"
          filterable
          remote
          reserve-keyword
          placeholder="请输入姓名搜索"
          :remote-method="employeeMethod"
          :loading="employeeLoading"
          @change="employeeChange"
          @blur="closeEmployee">
          <el-option
            v-for="item in employees"
            :key="item.employeeId"
            :label="item.name"
            :value="item.employeeId"
            style="width: 300px;">
            <span style="float: left">{{ item.name }}
                <span style="color: #8492a6; font-size: 8px">{{item.workingNum>0?' （服务中）':''}}</span>
            </span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.deptName }}</span>
          </el-option>
        </el-select>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 分配服务人员</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {employee, order} from '@/api'

export default {
  name: 'OrderAllot',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    orderFormId: {
      type: String
    }
  },
  watch: {
    dialogVisible (newValue) {
      if (newValue) this.getData()
    }
  },
  data () {
    return {
      loading: false,
      orgCode: this.$store.state.user.orgCode,
      employees: [],
      employeeAll: [],
      employeeLoading: false,
      dynamicTags: [],
      entities: [],
      inputVisible: false,
      inputValue: ''
    }
  },
  created () {
    this.getEmployeeAll('')
  },
  methods: {
    async getData () {
      this.loading = true
      let {data} = await order.getOrderEmployeeList(this.orderFormId)
      this.loading = false
      this.entities = data
      for (let entity of data) {
        this.dynamicTags.push(entity.name)
      }
    },
    async submit () {
      this.loading = true
      let {code} = await order.updateOrderEmployee(this.entities, this.orderFormId)
      this.loading = false
      this.close()
      if (code === 0) {
        this.$message({
          message: '分配成功！',
          type: 'success'
        })
      } else {
        this.$message('网络错误，请稍后重试！')
      }
    },
    employeeChange (value) {
      let orderForm = this.employees.find((elem) => {
        return elem.employeeId === value
      })
      let index = this.dynamicTags.indexOf(orderForm.name)
      if (index < 0) {
        this.dynamicTags.push(orderForm.name)
        this.entities.push({
          name: orderForm.name,
          employeeId: orderForm.employeeId,
          orderFormId: this.orderFormId,
          createUser: this.$store.state.user.userId
        })
      } else {
        this.$message('已添加！')
      }
    },
    closeEmployee () {
      setTimeout(() => {
        this.inputVisible = false
        this.inputValue = ''
      }, 100)
    },
    employeeMethod (query) {
      if (query !== '') {
        this.employeeLoading = true
        this.getEmployeeAll(query)
      } else {
        this.employees = this.employeeAll
      }
    },
    async getEmployeeAll (value) {
      let {data} = await employee.getEmployeeList({
        orgCode: this.$store.state.user.orgCode,
        name: value
      })
      this.employeeLoading = false
      if (this.employeeAll.length === 0) this.employeeAll = data
      this.employees = data
      return data
    },
    close () {
      this.entities = []
      this.dynamicTags = []
      this.$emit('dialogVisible', false)
    },
    handleClose (tag) {
      let index = this.dynamicTags.indexOf(tag)
      this.dynamicTags.splice(index, 1)
      this.entities.splice(index, 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.focus()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-tag {
    margin: 10px;
  }
  .button-new-tag {
    margin: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    border: 0;
    width: 160px;
    margin: 9px 8px;
    vertical-align: bottom;
    input {
      height: 28px;
    }
  }
</style>
